import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AccessRequest from './pages/access-request';
import MarketingLanding from './pages/marketing-landing';
import MatchManagement from './pages/match-management';
import OpportunityFeed from './pages/opportunity-feed';
import EmployerDashboard from './pages/employer-dashboard';
import AnonymousProfileGenerator from './pages/anonymous-profile-generator';
import AdminControlPanel from './pages/admin-control-panel';
import CandidateOnboarding from './pages/candidate-onboarding';
import ExecutivePreviewGallery from './pages/executive-preview-gallery';
import SecureChatInterface from './pages/secure-chat-interface';
import NotificationCenter from './pages/notification-center';
import UserPreferencesCenter from './pages/user-preferences-center';
import AdminPortalLogin from './pages/admin-portal-login';
import AdminPortalDashboard from './pages/admin-portal-dashboard';
import SalesPipelineKanbanBoard from './pages/sales-pipeline-kanban-board';
import VideoInterviewRoom from './pages/video-interview-room';
import SuperAdminPortal from './pages/super-admin-portal';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<MarketingLanding />} />
        <Route path="/access-request" element={<AccessRequest />} />
        <Route path="/marketing-landing" element={<MarketingLanding />} />
        <Route path="/executive-preview-gallery" element={<ExecutivePreviewGallery />} />
        <Route path="/senior-professionals-gallery" element={<ExecutivePreviewGallery />} />
        <Route path="/match-management" element={<MatchManagement />} />
        <Route path="/opportunity-feed" element={<OpportunityFeed />} />
        <Route path="/employer-dashboard" element={<EmployerDashboard />} />
        <Route path="/anonymous-profile-generator" element={<AnonymousProfileGenerator />} />
        {/* TEMPORARY BYPASS - Direct admin access without authentication */}
        <Route path="/admin-temp-access" element={<AdminControlPanel />} />
        <Route path="/admin-control-panel" element={<AdminControlPanel />} />
        <Route path="/admin-portal-login" element={<AdminPortalLogin />} />
        <Route path="/admin-portal-dashboard" element={<AdminPortalDashboard />} />
        <Route path="/super-admin-portal" element={<SuperAdminPortal />} />
        <Route path="/candidate-onboarding" element={<CandidateOnboarding />} />
        <Route path="/secure-chat-interface" element={<SecureChatInterface />} />
        <Route path="/notification-center" element={<NotificationCenter />} />
        <Route path="/user-preferences-center" element={<UserPreferencesCenter />} />
        <Route path="/sales-pipeline-kanban-board" element={<SalesPipelineKanbanBoard />} />
        <Route path="/video-interview-room" element={<VideoInterviewRoom />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
